import type { FunctionComponent } from 'react';
import type { RoadmapEvent } from '../../../interfaces/event';
import type { IMap } from '../../../interfaces/generic';
import type { IEventCoordinates } from '../../../interfaces/projection';
import { CashEventIcon } from './CashEventIcon';

interface IProps {
    yearEventMap: IMap<IEventCoordinates>;
    clientOutput?: boolean;
}

export const CashEventPane: FunctionComponent<IProps> = ({ yearEventMap, clientOutput }) => {
    if (!yearEventMap) {
        return null;
    }

    const getFirstTopicKeyOfEventList = (events: RoadmapEvent[]) => events[0].topicKey;

    const isMaturity = (events: RoadmapEvent[]) => events[0].eventType === 'MATURITY';

    return (
        <>
            {Object.entries(yearEventMap)?.map(
                ([year, entry]) =>
                    entry.eventsAtCoordinate &&
                    entry.eventsAtCoordinate.length > 0 &&
                    !isNaN(entry.x) &&
                    !isNaN(entry.y) && (
                        <CashEventIcon
                            key={year}
                            isMaturity={isMaturity(entry.eventsAtCoordinate)}
                            topicKey={getFirstTopicKeyOfEventList(entry.eventsAtCoordinate)}
                            clientOutput={clientOutput}
                            showSingleIcon={!!entry.showSingleIcon}
                            amountEvents={entry.eventsAtCoordinate.length}
                            positionX={entry.x}
                            positionY={entry.y}
                        />
                    ),
            )}
        </>
    );
};
